import React, { useState, useEffect } from "react";
import ExploreSection from "./exploreSection/index";
import CustomizationSection from "./customiztionSection/index";
import CategorySection from "./categorySection";
import NewProducts from "./newProductsSection/index";
import BannerSection from "./bannerSection/index";
import SeoHelmet from "app/layout/seoHelmet";
import useCustomer from "app/state/hooks/customerHooks/useCustomer";
import ModalWrapper from "app/layout/login/modalWrapper";
import { useHistory } from "react-router-dom";
import UpcomingSection from "./upcomingSection/index";
import BannerSectionV2 from "./bannerSectionV2";
import CategorySectionV2 from "./categorySectionV2";
import UpcomingSectionV2 from "./upcomingSectionV2";
import ExploreSectionV2 from "./exploreSectionV2";
import CustomizationSectionV2 from "./customiztionSectionV2/index";
import CollectionsSection from "./collections";
import LeadingTheWay from "./leadingTheWay";
const Home = () => {
  const { location } = useHistory();
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [activeItem, setActiveItem] = useState("1");
  const toggleTabs = (tab) => {
    if (activeItem !== tab) {
      setActiveItem(tab);
    }
  };
  const { isLoggedIn } = useCustomer();
  useEffect(() => {
    if (location.state) {
      if (location?.state?.from?.pathname === "/reset-password") {
        toggleModal();
      }
    }
  }, []);

  return (
    <React.Fragment>
      <SeoHelmet
        title="Prima Lighting"
        url=""
        description={"Prima Lighting - Home"}
      />
      <BannerSectionV2 />
      <CategorySectionV2 />
      <CustomizationSectionV2 />
      <CollectionsSection />

      <UpcomingSectionV2 />
      <ExploreSectionV2 />
      <LeadingTheWay />

      <ModalWrapper
        toggleModal={toggleModal}
        modal={!isLoggedIn && modal}
        activeItem={activeItem}
        toggleTabs={toggleTabs}
      />
    </React.Fragment>
  );
};
export default Home;
